import BaseApiClient from '../BaseApiClient';
import { TaskProductPaymentTypeInterface } from '@interfaces/TaskProductPaymentType.interface';

export class ApiTaskProductPaymentType extends BaseApiClient {
  /**
   * Get all items
   */
  async all(): Promise<Array<TaskProductPaymentTypeInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/task-product-payment-type?page[size]=999')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get item
   */
  async get(id: number): Promise<TaskProductPaymentTypeInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/task-product-payment-type/${id}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { taskProductPaymentTypeQueryKeys } from './query-keys';
export {
  useTaskProductPaymentTypeQuery,
  useTaskProductPaymentTypesQuery
} from './use-task-product-payment-type-queries';
